import { AbstractControl, ValidationErrors } from "@angular/forms";
import { DateTime } from "luxon";

export const invalidEffectiveDateRangeValidator = (control: AbstractControl): ValidationErrors | null =>{
    
    const parent = control?.parent as any;
    if(!parent) return null;
    const effectiveFrom = parent?.get('effectiveFrom') ? new Date(parent?.get('effectiveFrom')?.value) : null;
    const effectiveTo = parent?.get('effectiveTo') ? new Date(parent?.get('effectiveTo')?.value) : null;

    if (effectiveFrom && effectiveTo && effectiveFrom > effectiveTo) {
        return { invalidEffectiveDateRange: true };
    }
    return null;
}